import { AppIcon } from '@backstage/core-components';
import {
  createExternalRouteRef,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { apiDocsRootRouteRef } from './routes';

const registerApiRouteRef = createExternalRouteRef({
  defaultTarget: 'catalog-import.importPage',
});

export const apiDocsPlugin = createFrontendPlugin({
  pluginId: 'api-docs',
  title: 'APIs',
  icon: <AppIcon fontSize="inherit" id="kind:api" />,
  routes: {
    root: apiDocsRootRouteRef,
  },
  externalRoutes: {
    registerApi: registerApiRouteRef,
  },
});
